import type { CSSProperties } from 'react'
import React from 'react'

import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

import { RemovableUpload } from '../RemovableUpload/RemovableUpload'
import { UploadedImage } from '../UploadedImage/UploadedImage'
import * as S from './styled'

type Props = {
  id: string
  image: string | File
  count: number
  onImageRemove: (imageId: string) => void
}

export const PostGalleryImage = ({ id, image, count, onImageRemove }: Props) => {
  const { isDragging, attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id,
  })

  const style: CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition: transition || undefined,
    opacity: isDragging ? 0.5 : undefined,
    cursor: 'grab',
  }

  return (
    <S.ImageContainer ref={setNodeRef} style={style} count={count} {...attributes} {...listeners}>
      <RemovableUpload
        onRemove={() => {
          onImageRemove(id)
        }}
      >
        <UploadedImage image={image} objectFit="contain" />
      </RemovableUpload>
    </S.ImageContainer>
  )
}
